import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-supervisor-exam',
  templateUrl: './supervisor-exam.component.html',
  styleUrls: ['./supervisor-exam.component.scss']
})
export class SupervisorExamComponent implements OnInit {
  SuperExamForm: FormGroup;
  SuperExamSearchForm: FormGroup;
  examList: any[];
  filteredExamList: any;
  userList: [];
  clgexamData: any[] = [];
  filteredclg: any[] = [];
  filteredUserList: any;
  examData = [];
  isShown = false;
  collegeOneList: any;
  examOneList: any;
  isShownExamList = false;
  isShownUserList = false;
  isShownExamDiv = false;
  isShownUserDiv = false;
  isUserRadioBtn = false;
  isExamRadioBtn = false;
  submitexam = false;
  reset = false;
  submituser = false;
  // clgArr:any[];
  // examArr:any[];
  map = new Map<String, String>();
  userexamList: any;
  checked: boolean;
  dialogRef: MatDialogRef<any>;
  uncheckedexamList = [];
  checkedexamList = [];
  uncheckedUserList = [];
  checkedUserList = [];
  SessionNo: any;
  selectUser: any;
  selectExam: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  searchTerm: string = '';
  setIntervalSearch: any;
  constructor(
    public umsService: UmsService,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    public router: Router,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService
  ) {}
  userId;
  examId;
  UserArr: FormArray;
  ExamArr: FormArray;
  userPermission:any;
  utp: any;
  superCreate = true;
  UserCollege
  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Supervisor-Exam' && element.PCreate == false)
      {
          this.superCreate = false;  
      }
      // if(element.PageName == 'Session-Cutoff' && element.PUpdate == false)
      // {
      //     this.sessUpdate = false;  
      // }   
      // if(element.PageName == 'State' && element.PDelete == false)
      // {
      //     this.townDelete = false;  
      // } 
    });
  }
    this.isUserRadioBtn = true;
    this.isExamRadioBtn = true;
    this.isShownExamList = false;
    this.isShownUserList = false;
    this.SuperExamForm = this.fb.group({
      UserArr: this.fb.array([]),
      ExamArr: this.fb.array([]),
      exam: new FormControl(''),
      user: new FormControl(''),
      radio:new FormControl(''),
    });
    let id = {};
    // this.fetchSelectedExamCollege(id);
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  // getControls() {
  //   return (this.SuperExamForm.get('UserArr') as FormArray).controls;
  // }
  // getControls1() {
  //   return (this.SuperExamForm.get('ExamArr') as FormArray).controls;
  // }
  getControls() {
 
    if (this.searchTerm === '') {
      return (this.SuperExamForm.get('UserArr') as FormArray).controls;
    } else {
      return (this.SuperExamForm.get('UserArr') as FormArray).controls.filter(control =>  control.value.CoCgCgCode.toLowerCase().includes(this.searchTerm) )
    }
  }
  getControls1() {
    if (this.searchTerm === '') {
      return (this.SuperExamForm.get('ExamArr') as FormArray).controls;
    } else {
      return (this.SuperExamForm.get('ExamArr') as FormArray).controls.filter(control =>  control.value.CoCgCoCode.toLowerCase().includes(this.searchTerm) )
    }
  }
//  passed code 
  userClick() {
    this.clear();
    this.spinner.show();
    let payload = {}
    this.umsService.getUserList(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.userList = res.data;
        this.filteredUserList = this.userList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
    this.isUserRadioBtn = true;
    this.isExamRadioBtn = false;
    this.isShownUserDiv = true;
    this.isShownExamDiv = false;
    this.isShownExamList = false;
    this.isShownUserList = false;
    // bar.then(() => {
    //   this.addclgexam();
    // });
  }

  examClick() {
    this.clear();
    this.spinner.show();
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
 const payload = {};
    payload['CgCode'] = this.UserCollege;
    this.umsService.getExam(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.examList = res.data;
        this.filteredExamList = this.examList.slice();
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
    this.isUserRadioBtn = false;
    this.isExamRadioBtn = true;
    
    this.isShownUserDiv = false;
    this.isShownExamDiv = true;
    
    this.isShownExamList = false;
    this.isShownUserList = false;
  }
  // passed code endx
selected;
oneUserClick(e,search) {
  this.spinner.show();
    this.selected = e;
      this.selectUser = e;
    this.isShownExamList = true;
    this.isShownUserList = false;
    this.submitexam = true;
    this.submituser = false;
    this.reset = true;
    this.uncheckedexamList = [];
    this.checkedexamList = [];
    let payload = {};
    this.userId = e;
     payload['SearchString'] = search;
    this.umsService.getExam(payload).subscribe((allres) => {
      this.spinner.hide();
      if (allres.data.length > 0) {
        let allexamList = [];
        allexamList = allres.data;
       
        const userFetchPayload = {};
        userFetchPayload['SuOpid'] = e;
        userFetchPayload['SuEmId'] = '';
        this.umsService.getUserExam(userFetchPayload).subscribe((res) => {
            this.userexamList = res.data;
            this.spinner.hide();
            this.SuperExamForm = this.fb.group({
              exam: new FormControl(''),
              user: new FormControl(e),
              UserArr: this.fb.array([]),
              ExamArr: this.fb.array([]),
            });
            if (allexamList !== undefined) {
              this.ExamArr = this.SuperExamForm.get('ExamArr') as FormArray;
              allexamList.map((element, i) => {
                element['checked'] = false;
                this.userexamList.forEach((elementA) => {
                  if (
                    element.EmId == elementA.SuEmId &&
                    e == elementA.SuOpid
                  ) {
                    element['checked'] = true;
                  }
                });
              });
              allexamList.forEach((element) => {
                this.ExamArr.push(
                  this.fb.group({
                    clgexamcheckbox: new FormControl(element.checked),
                    CoCgCoCode: new FormControl(element.EmName),
                    SuEmId: new FormControl(element.EmId),
                    SuOpid: new FormControl(e),
                    CoCgCgName: new FormControl(element.CgName),
                    toggle: false,
                  })
                );
                if(element.checked == false){
                  this.uncheckedexamList.push(element);
                }else{
                  this.checkedexamList.push(element);
                }
              });
            }
          });
      } else {
      }
    });
  }

  oneExamClick(e,search) {
    this.spinner.show();
    this.selected = e;
     this.selectUser = e;
    this.uncheckedUserList = [];
    this.checkedUserList = [];
    this.isShownExamList = false;
    this.isShownUserList = true;
    this.submitexam = false;
    this.submituser = true;
    this.reset = true
    let payload = {};
    this.userId = e;
    payload['SearchString'] = search;
    this.umsService.getUserList(payload).subscribe((allResCollege) => {
      this.spinner.hide();
      if (allResCollege.data.length > 0) {
        let allUserList = [];
        allUserList = allResCollege.data;
        // this.spinner.hide();
        const examFetchPayload = {};
        examFetchPayload['SuOpid'] = '';
        examFetchPayload['SuEmId'] = e;
        this.umsService.getUserExam(examFetchPayload).subscribe((res) => {
            this.userexamList = res.data;
            this.SuperExamForm = this.fb.group({
              exam: new FormControl(e),
              user: new FormControl(''),
              UserArr: this.fb.array([]),
              ExamArr: this.fb.array([]),
            });
            if (allUserList !== undefined) {
              this.UserArr = this.SuperExamForm.get('UserArr') as FormArray;
              allUserList.map((element, i) => {
                element['checked'] = false;
                this.userexamList.forEach((elementA) => {
                  if (
                    element.LoginId == elementA.SuOpid &&
                    e == elementA.SuEmId
                  ) {
                    element['checked'] = true;
                  }
                });
              });
              allUserList.forEach((element) => {
                this.UserArr.push(
                  this.fb.group({
                    clgexamcheckbox: new FormControl(element.checked),
                    CoCgCgName: new FormControl(''),
                    SuOpid: new FormControl(element.LoginId),
                    SuEmId: new FormControl(e),
                    CoCgCgCode: new FormControl(element.LoginFullName),
                    toggle: false,
                  })
                );
                if(element.checked == false){
                  this.uncheckedUserList.push(element);
                }else{
                  this.checkedUserList.push(element);
                }
              });
            }
          });
      } else {
      }
    });    
  }

  clear() {
    this.SuperExamForm = this.fb.group({
      exam: new FormControl(''),
      user: new FormControl(''),
      UserArr: this.fb.array([]),
      ExamArr: this.fb.array([]),
    });
  }

  removeExamArr(i) {
    this.ExamArr.removeAt(i);
  }

  removeCollegeArr(i) {
    this.ExamArr.removeAt(i);
  }

  // fetchUser() {
  //   const payload = {};

  //   this.umsService.getUserList(payload).subscribe((res) => {
  //     if (res.status) {
  //       this.userList = res.data;
  //       this.filteredUserList = this.userList.slice();
  //     } else {
  //       // this.apimicroservice.openSnackbar(res.message);
  //     }
  //   });
  // }

  submit() {
      this.addclgexam();    
  }

  submit1() {
    this.addclgexam1();
  }

  addclgexam() {
    let payload = this.SuperExamForm.value;
    payload['ExamArr'].forEach((element,i) => {
      if(element.clgexamcheckbox == true){
        this.uncheckedexamList.forEach(elementA => {
          if(element.SuEmId == elementA.EmId){
            let xxxx = {};
            xxxx['SuOpid'] = element.SuOpid;
            xxxx['SuEmId'] = element.SuEmId;
            this.umsService.AddUserExam(xxxx).subscribe((res) => {
            });
          }
        });
      }
      if(element.clgexamcheckbox == false){
        this.checkedexamList.forEach(elementA => {
          if(element.SuEmId == elementA.EmId) {
            this.slideToggleChange(element,'exam');
          }
        });
      }
    });
    let data = {};
    data['message'] = "Submitted Successfully";
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.oneUserClick(this.selected,'') 
      this.searchTerm = ''
    });
  }

  addclgexam1() {
    let payload = this.SuperExamForm.value;
    payload['UserArr'].forEach((element,i) => {
      if(element.clgexamcheckbox == true){
        this.uncheckedUserList.forEach(elementA => {
          if(element.SuOpid == elementA.LoginId){
            let xxxx = {};
            xxxx['SuOpid'] = element.SuOpid;
            xxxx['SuEmId'] = element.SuEmId;
            this.umsService.AddUserExam(xxxx).subscribe((res) => {
            });
          }
        });
      }
      if(element.clgexamcheckbox == false){
        this.checkedUserList.forEach(elementA => {
          if(element.SuOpid == elementA.LoginId) {
            this.slideToggleChange(element,'user');
          }
        });
      }
    });
    let data = {};
    data['message'] = "Submitted Successfully";
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.oneExamClick(this.selected,'') 
      this.searchTerm = ''
    });
  }

  freshExamCollageMapping(allrecord, cgcode) {
    let data = allrecord.data;
    this.SuperExamForm = this.fb.group({
      exam: new FormControl(''),
      user: new FormControl(''),
      UserArr: this.fb.array([]),
      ExamArr: this.fb.array([]),
    });
    this.userList = data.ExamArr;
    if (data !== undefined) {
      data.map((element, i) => {
        this.ExamArr = this.SuperExamForm.get('ExamArr') as FormArray;
        this.ExamArr.push(
          this.fb.group({
            clgexamcheckbox: new FormControl(false),
            CoCgCoCode: new FormControl(element.EmName),
            EmId: new FormControl(element.EmId),
            CoCgCgCode: new FormControl(cgcode),
            CoCgCgName: new FormControl(element.CgName),
            toggle: false,
          })
        );
      });
    }
  }

  slideToggleChange(e, type) {
    if (type == 'exam') {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: {
          SuOpid: e.SuOpid,
          SuEmId: e.SuEmId,
        },
      };
      this.httpClient
        .delete(environment.serviceUrl + '/admin/userToExam', options)
        .subscribe(
          (s) => {},
          (ERROR: HttpErrorResponse) => {}
        );
    } else if ( type == 'user') {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: {
          SuOpid: e.SuOpid,
          SuEmId: e.SuEmId,
        },
      };
      this.httpClient
        .delete(environment.serviceUrl + '/admin/userToExam', options)
        .subscribe(
          (s) => {},
          (ERROR: HttpErrorResponse) => {}
        );
    }
  }

  back() {
    // this.SuperExamForm.reset();
    // window.location.reload();
    this.isShownUserDiv = false;
    this.isShownExamDiv = false;
    this.isShownExamList = false;
    this.isShownUserList = false;
    this.submitexam = false;
this.submituser = false;
this.reset = false;
    this.SuperExamForm = this.fb.group({
      UserArr: this.fb.array([]),
      ExamArr: this.fb.array([]),
      exam: new FormControl(''),
      user: new FormControl(''),
      radio:new FormControl(''),
    });
    this.UserArr.clear();
    this.ExamArr.clear();
  }

  print(){
    let submitpayload = this.SuperExamForm.value;
    let payload1 = {}
    payload1['MenuName'] = 'SupervisorExam';
    payload1['CallMode'] = 'E';
    payload1['ByOp'] = 'Y';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 121,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }
  redirect(to): void {
    this.router.navigate([to]);
  }


  // applyFilter(event: any){
  //   let search = event.target.value;
   
  //   if(this.submituser == true){
  //     this.oneExamClick(this.selectExam,search)
  //   }
  //   else if(this.submitexam == true){
  //     this. oneUserClick(this.selectUser,search)
  //   }
    
  // }
  applyFilter(event: any){
    let search = event.target.value;
    this.searchTerm = search.toLowerCase();
  }

  keypress() {

    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.examList = [];
    // this.userList = [];
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['SearchString'] = this.SuperExamSearchForm.value;
    this.umsService.searchExam(payload).subscribe(res => {
      this.filteredExamList = res.data;
      // this.filteredUserList = res.data;
      this.totalItems = res.data[0].TotalRecords;
    }, (ERROR: HttpErrorResponse) => {
      this.examList = [];
      // this.userList = [];
    });
    },1000)
   

  }
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    // const newPageIndex = Math.floor(event.pageSize * event.pageIndex / this.pageSize);
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    // this.getCollegeData();
  }
}
// addUserCourse